// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoOftalmologicoOsdi {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"OSDI",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"¿Durante la última semana ha experimentado algo de lo siguiente?" ,bold:true },

                {valor:"", descripcion:"", tipo:1 ,label:"1. Sensibilidad a la luz en los ojos" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. Sensación de arenilla en ojos" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. Dolor en los ojos" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. Visión borrosa" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. Visión pobre (disminución)" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje subtotal de las preguntas 1 a 5 (A)" },

                {valor:"", descripcion:"", tipo:0 ,label:"¿La última semana ha tenido problemas en los ojos que le han limitado realizar lo siguiente?" ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"6. Leer" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"7. Manejar en la noche" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"8. Trabajar con la computadora o al usar un cajero automático" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"9. Ver la televisión" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje subtotal de las preguntas 6 a 9 (B)" },

                {valor:"", descripcion:"", tipo:0 ,label:"¿La última semana ha sentido incomodidad en los ojos en alguna de las siguientes situaciones?" ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"10. Viento" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"11. Sitios con baja humedad (muy secos)" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:1 ,label:"12. Sitios con aire acondicionado" ,data:["Nunca","A veces","La mitad del tiempo","La mayor parte del tiempo","Todo el tiempo"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje subtotal de las preguntas 10 a 12 (C)" },
                {valor:"", descripcion:"", tipo:3 ,label:"PUNTAJE OSDI", bold:true },
                {valor:"", descripcion:"", tipo:5 ,label:"Calcular", click:7 }

            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoOftalmologicoOsdi.js